type BenefitRow = {
  label: string
  subtext?: string
  elite: boolean
  infinite: boolean
}

const BENEFIT_ROWS: BenefitRow[] = [
  {
    label: 'Personalised Portfolio Insights',
    subtext: 'Rebalancing, Allocation, Tax harvesting, Power Ranks etc..',
    elite: true,
    infinite: true
  },
  { label: 'One-on-One wealth management', elite: false, infinite: true },
  { label: 'Customised Portfolio Strategies', elite: false, infinite: true },
  { label: 'Goal Planning', elite: false, infinite: true },
  { label: 'End-to-end Execution Support', elite: false, infinite: true },
  { label: 'Shared Accountability', elite: false, infinite: true }
]

export const InfiniteLandingBenefits = () => {
  return (
    <div className='bg-white py-12'>
      <h2 className='text-center font-libre-caslon text-[24px] tracking-[-0.72px] text-black'>
        The difference is
        <br />
        ownership & responsibility.
      </h2>
      <p className='mt-6 text-center font-libre-franklin text-[14px] font-normal leading-[1.02] text-[#697D86]'>
        Elite elevates your management.
        <br />
        <span className='font-libre-caslon text-[16px] text-black leading-[1.7]'>Infinite owns it end-to-end.</span>
      </p>

      <div className='relative mt-9 flex items-center justify-center bg-gradient-to-b from-[#FFFFFF] to-[#E9F5FF] to-[115.51%] px-[105px] pt-[12px] pb-[11px]'>
        <p className='font-libre-franklin text-center text-[12px] font-normal leading-normal text-black whitespace-nowrap'>
          Two ways to build serious wealth.
        </p>
        <svg className="rotate-180 absolute bottom-0" xmlns="http://www.w3.org/2000/svg" width="402" height="2" viewBox="0 0 402 2" fill="none">
          <path d="M0 0.800049H401.878" stroke="url(#paint0_radial_25_546)" stroke-width="1.6" />
          <defs>
            <radialGradient id="paint0_radial_25_546" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(200.939 -6.08481) rotate(90) scale(170.671 170.671)">
              <stop stop-color="#2888EF" />
              <stop offset="0.4375" stop-color="#28B3EF" stop-opacity="0.5625" />
              <stop offset="1" stop-color="#2888EF" stop-opacity="0" />
            </radialGradient>
          </defs>
        </svg>
      </div>

      <div className='px-5 pt-5'>
        <div className='grid grid-cols-[1fr_96px_96px] border-b border-[#E3EBEE] bg-white py-3 text-center font-libre-franklin text-[14px] font-semibold'>
          <div className='text-left pl-3 text-[12px] font-normal text-[#8A8A8A]'></div>
          <div>Elite</div>
          <div>Infinite</div>
        </div>
        {BENEFIT_ROWS.map(({ label, subtext, elite, infinite }) => (
          <div key={label} className='grid grid-cols-[1fr_96px_96px] items-center border-b border-[#E3EBEE] py-3 last:border-b-0'>
            <div className='pl-3'>
              <p className='font-libre-franklin text-[11px] font-medium text-black'>{label}</p>
              {subtext ? (
                <p className='mt-1 font-libre-franklin text-[10px] font-normal leading-[1.3] text-[#95A3AF]'>{subtext}</p>
              ) : null}
            </div>
            <p className='text-center text-[18px] text-[#95A3AF]'>{elite ? '✓' : '✕'}</p>
            <p className='text-center text-[18px] text-[#2888EF]'>{infinite ? '✓' : '✕'}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
